module.exports = __webpack_public_path__ + "img/eu2.f0fbb931.jpg";